<template>
  <div>
    <CoachingSurvey />
  </div>
</template>

<script>
import CoachingSurvey from "@/components/CoachingSurvey.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    CoachingSurvey
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>